export const POST_AGENT = 'POST_AGENT';
export const LIST_AGENT = 'LIST_AGENT';
export const GET_AGENT = 'GET_AGENT';
export const GET_AGENT_SELETO = 'GET_AGENT_SELETO';
